import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Image from "next/image";
import { ProductImage } from "@/types/product";

interface ProductCarouselProps {
  images: ProductImage[];
}

export default function ProductCarousel({ images }: ProductCarouselProps) {
  return (
    <div className="w-full lg:w-2/3">
      <Carousel className="w-full">
        <CarouselContent>
          {images.map((image, index) => (
            <CarouselItem key={index}>
              <div className="aspect-square bg-gray-100 border rounded-xl flex items-center justify-center">
                <Image 
                  src={image.src} 
                  alt={image.alt} 
                  width={800} 
                  height={800} 
                  className="rounded-xl" 
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        {/* 모든 화면에서 미리보기 안쪽에 배치해 좌우 사이드바에 가려지지 않도록 한다. */}
        <CarouselPrevious className="left-2 z-10 bg-background shadow-md dark:bg-background dark:hover:bg-accent" />
        <CarouselNext className="right-2 z-10 bg-background shadow-md dark:bg-background dark:hover:bg-accent" />
      </Carousel>
    </div>
  );
}
